import * as React from 'react';
import { TableFetchParams, tableQueryMaker } from '@core/table';
import { useService } from '@core/inversify-react';

import { GetDiscountUsersRepoType, IGetDiscountUsersRepo } from '../../repos';
import { UsersTableContext } from '../../contexts';

export const useDiscountUsersTableContext = () => {
  const getUsersRepo = useService<IGetDiscountUsersRepo>(GetDiscountUsersRepoType);

  const onFetch = React.useCallback(
    async (params: TableFetchParams) => {
      const result = await getUsersRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getUsersRepo],
  );

  return { onFetch, context: UsersTableContext };
};
